module.exports = __webpack_public_path__ + "static/media/pause.3b7f854d.png";